export default {
  all: 'showAllStations',
  jem: 'showActiveJem',
  oee: 'showActiveOee',
};
